import { render, staticRenderFns } from "./ArticalCard.vue?vue&type=template&id=616696ef&scoped=true&"
import script from "./ArticalCard.vue?vue&type=script&lang=js&"
export * from "./ArticalCard.vue?vue&type=script&lang=js&"
import style0 from "./ArticalCard.vue?vue&type=style&index=0&id=616696ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616696ef",
  null
  
)

export default component.exports